module.exports = __webpack_public_path__ + "static/media/Pouť-97-korunovace0.d7bb9583.jpg";